let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fDUTy")).then(() => parcelRequire('64Z8P'));